import { IconButton, LinearProgress, Stack, Typography } from '@mui/material'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { percentOf } from './submissionRate'
import { styles } from './DrillRowHeader.styles'

const RowProgress = ({ rate, onDark }: { rate: number | null, onDark: boolean }): JSX.Element => {
  const value = percentOf(rate)
  return (
    <Stack direction='row' alignItems='center' gap='10px' sx={styles.progressRow}>
      <LinearProgress variant='determinate' value={value} sx={styles.progressBar(onDark, value === 100)} />
      <Typography variant='body2' sx={styles.progressValue(onDark)}>{value}%</Typography>
    </Stack>
  )
}

interface Props {
  name: string
  rate: number | null
  open: boolean
  onToggle: () => void
  organizationId: number
}

export const DrillRowHeader = ({ name, rate, open, onToggle, organizationId }: Props): JSX.Element => (
  <Stack
    direction='row' alignItems='center' gap='16px' sx={styles.header(open)}
    onClick={onToggle} data-testid={`p2pDrillRow-${organizationId}`}
  >
    <Typography variant='body1' sx={styles.name(open)}>{name}</Typography>
    <RowProgress rate={rate} onDark={open} />
    <IconButton size='small' onClick={onToggle} data-testid={`p2pExpand-${organizationId}`} sx={styles.expand(open)}>
      {open ? <KeyboardArrowUpIcon fontSize='small' /> : <KeyboardArrowDownIcon fontSize='small' />}
    </IconButton>
  </Stack>
)
